import React, { useState } from 'react';
import { useApiClient } from '../../ApiService/useApiClient';
import { Table, Form, Button, Spinner, Alert } from 'react-bootstrap';
import { ChartBar } from '../Chart/Charts';

const TenantUsageReport = () => {

 const api = useApiClient()

  const [tenantId, setTenantId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchReport = async () => {
    setLoading(true);
    setError('');
    try {
    
    const formattedStart = new Date(startDate).toISOString(); // ensures correct format
    const formattedEnd = new Date(endDate).toISOString();

    const response = await api.get(
        `api/TenantUsage/api-usage-report?tenantId=${tenantId}&startDate=${new Date(startDate).toISOString()}&endDate=${new Date(endDate).toISOString()}`
    );  
    setReportData(response.data);

    } catch (err) {
      console.error(err);
      setError(err.response?.data || 'Error fetching report');
    }
    setLoading(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!tenantId || !startDate || !endDate) {
      setError('Please enter all fields');
      return;
    }
    fetchReport();
  };

  // === Prepare Chart Data ===
  const labels = reportData.map(
    (item) => `${new Date(item.date).toLocaleDateString()} - ${item.endpoint}`
  );

  const chartValues = reportData.map((item) => item.apiCallCount);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'API Call Count',
        data: chartValues,
        backgroundColor: '#0d6efd',
        borderRadius: 4,
      },
    ],
    legend: true,
    xAxis: true,
    yAxis: true,
    ticksValue: '',
    barPercentage: 0.6,
    categoryPercentage: 0.5,
    maxTicksLimit: 12,
  };

  return (
    <div className="container mt-4">
      <h3>Tenant API Usage Report</h3>

      <Form className="mb-3" onSubmit={handleSubmit}>
        <Form.Group className="mb-2">
          <Form.Label>Tenant ID</Form.Label>
          <Form.Control
            type="number"
            value={tenantId}
            onChange={(e) => setTenantId(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label>Start Date</Form.Label>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label>End Date</Form.Label>
          <Form.Control
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            required
          />
        </Form.Group>
        <Button type="submit" disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : 'Generate Report'}
        </Button>
      </Form>

      {error && <Alert variant="danger">{error}</Alert>}

      {reportData.length > 0 && (
        <>
          <div style={{ height: 400, marginBottom: '2rem' }}>
            <ChartBar data={chartData} />
          </div>

          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Date</th>
                <th>Endpoint</th>
                <th>API Call Count</th>
              </tr>
            </thead>
            <tbody>
              {reportData.map((entry, index) => (
                <tr key={index}>
                  <td>{new Date(entry.date).toLocaleDateString()}</td>
                  <td>{entry.endpoint}</td>
                  <td>{entry.apiCallCount}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </div>
  );
};

export default TenantUsageReport;
